import React from 'react';
import { useSelector } from 'react-redux';
import RowContainer from '../common/CustomComponents/RowContainer';

const TermsOfUse = () => {
  const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
    return (
      tenantLayouts['TermsOfUse'] && 
        <div className={tenantLayouts['TermsOfUse'].className} id={tenantLayouts['TermsOfUse'].id}>
        {tenantLayouts['TermsOfUse'].sections.map((item,index) =>{
          return <RowContainer key={index} {...item} />;
        })}
        </div>
    );
};

export default TermsOfUse;